import NewsTeaserHorizontal from '@/components/modules/NewsTeaserHorizontal'
import StreamWidget from '@/components/modules/StreamWidget'
import GDPRVideoModule from '@/components/modules/GDPRVideoModule'
import OccasionsSlider from '@/components/modules/occasions/OccasionsSlider'
import EditorModule from '@/components/modules/EditorModule'
import UserOverview from '@/components/modules/user/UserOverview'
import TopStoryTeaser from '@/components/modules/TopStoryTeaser'
import CoachingsModule from '@/components/modules/CoachingsModule'
import DownloadsModule from '@/components/modules/DownloadsModule'
import GalleryModule from '@/components/modules/GalleryModule'
import KununuModule from '@/components/modules/KununuModule'
import GympassModule from '@/components/modules/GympassModule'
import NavigationSubpages from '@/components/modules/NavigationSubpages'
import WebNews from '@/components/modules/WebNews'
import ScoresModule from '@/components/modules/ScoresModule'
import ShopModule from '@/components/modules/ShopModule'
import HeroRegisterModule from '@/components/modules/HeroRegisterModule'
import LandingPageTeaserModule from '@/components/modules/LandingPageTeaserModule'
import UseCasesModule from '@/components/modules/UseCasesModule'
import EditorialModule from '@/components/modules/EditorialModule'
import LocationModule from '@/components/modules/LocationModule'


export default {
  modulesMapping() {
    // modules mapping
    return [
      { type: 'articleteaser', component: 'NewsTeaserHorizontal' },
      { type: 'coachings', component: 'CoachingsModule' },
      { type: 'gdpr', component: 'GDPRVideoModule' },
      { type: 'occasions', component: 'OccasionsSlider' },
      { type: 'profileteaser', component: 'UserOverview' },
      { type: 'topteaser', component: 'TopStoryTeaser' },
      { type: 'downloads', component: 'DownloadsModule' },
      { type: 'editor', component: 'EditorModule' },
      { type: 'gallery', component: 'GalleryModule' },
      { type: 'gympass', component: 'GympassModule' },
      { type: 'kununu', component: 'KununuModule' },
      { type: 'navigation_subpages', component: 'NavigationSubpages' },
      { type: 'webnews', component: 'WebNews' },
      { type: 'scores', component: 'ScoresModule' },
      { type: 'stream_widget', component: 'StreamWidget' },
      { type: 'shop', component: 'ShopModule' },
      { type: 'hero_register', component: 'HeroRegisterModule' },
      { type: 'landing_page_teaser', component: 'LandingPageTeaserModule' },
      { type: 'use_cases', component: 'UseCasesModule' },
      { type: 'text_image_switch', component: 'EditorialModule' },
      { type: 'location', component: 'LocationModule' },
    ]
  },
  modulesImport: {
    NewsTeaserHorizontal,
    GDPRVideoModule,
    OccasionsSlider,
    UserOverview,
    TopStoryTeaser,
    CoachingsModule,
    DownloadsModule,
    EditorModule,
    GalleryModule,
    KununuModule,
    GympassModule,
    NavigationSubpages,
    WebNews,
    ScoresModule,
    StreamWidget,
    ShopModule,
    HeroRegisterModule,
    LandingPageTeaserModule,
    UseCasesModule,
    EditorialModule,
    LocationModule,
  },
}
